'use client';

import Link from 'next/link';

export default function NotFound() {
  return (
    <div className="flex items-center justify-center min-h-screen px-4">
      <div className="text-center max-w-md">
        <h1 className="text-6xl font-bold mb-4" style={{ color: '#395750' }}>404</h1>
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#1A2E29' }}>Page Not Found</h2>
        <p className="text-gray-600 mb-8">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link
          href="/"
          className="inline-flex items-center px-6 py-3 rounded-lg text-white font-medium transition-all hover:opacity-90"
          style={{ backgroundColor: '#395750' }}
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}
